import React from "react";
import { modalBGColor } from "utils/customStyles";

const SuccessMessage = ({ mainMessage, subMessage }) => {
  return (
    <div style={modalBGColor} className="py-8 px-12">
      <div className="text-2xl">{mainMessage}</div>
      {subMessage ? <div className="text-2xl">{subMessage}</div> : null}
    </div>
  );
};

export default SuccessMessage;
